import Axios from "axios";

// import JwtUtils from "../utils/jwtUtils";
import { apiHost } from "../constants/ApiConstants";
import apiClient from "./ApiClient";

export default class ApiTour {
  static async uploadTour(tourDatas) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    const dataForm = new FormData();

    dataForm.append(
      "imageCollection",
      tourDatas.backgroundImageFile,
      "-backgroundimage-" + tourDatas.backgroundImageFile.name
    );
    if (tourDatas.annotationImageFile)
      dataForm.append(
        "imageCollection",
        tourDatas.annotationImageFile,
        "-annotationimage-" + tourDatas.annotationImageFile.name
      );
    if (tourDatas.musicFile)
      dataForm.append(
        "imageCollection",
        tourDatas.musicFile,
        "-tourmusic-" + tourDatas.musicFile.name
      );
    if (tourDatas.inGameBackgroundImageFile)
      dataForm.append(
        "imageCollection",
        tourDatas.inGameBackgroundImageFile,
        "-ingamebackgroundimage-" + tourDatas.inGameBackgroundImageFile.name
      );
    dataForm.append("tourDatas", JSON.stringify(tourDatas));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    return await apiClient
      .post(
        `${apiHost}/newTour`,
        dataForm,
        {
          // headers: { Authorization: authHeader },
        },
        config
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async newGuestUserTourCode(tourCode) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(`${apiHost}/newGuestUserTourCode`, tourCode, {
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async updateToursOrdersIds(toursDatas) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(
        `${apiHost}/updateToursOrderIds`,
        {
          toursDatas: toursDatas,
        },
        {
          // headers: { Authorization: authHeader },
        }
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async updateTour(tourDatas, tourId) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    const dataForm = new FormData();

    if (tourDatas.backgroundImageFile)
      dataForm.append(
        "imageCollection",
        tourDatas.backgroundImageFile,
        "-backgroundimage-" + tourDatas.backgroundImageFile.name
      );
    if (tourDatas.musicFile)
      dataForm.append(
        "imageCollection",
        tourDatas.musicFile,
        "-tourmusic-" + tourDatas.musicFile.name
      );
    if (tourDatas.annotationImageFile)
      dataForm.append(
        "imageCollection",
        tourDatas.annotationImageFile,
        "-annotationimage-" + tourDatas.annotationImageFile.name
      );
    if (tourDatas.inGameBackgroundImageFile)
      dataForm.append(
        "imageCollection",
        tourDatas.inGameBackgroundImageFile,
        "-ingamebackgroundimage-" + tourDatas.inGameBackgroundImageFile.name
      );

    dataForm.append("tourDatas", JSON.stringify(tourDatas));
    dataForm.append("tourId", tourId);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        // Authorization: authHeader,
      },
    };

    return await apiClient
      .post(`${apiHost}/updateTour`, dataForm, config)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getTours() {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;
    return await apiClient
      .get(`${apiHost}/tours`, {
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        console.log("apitour get tours error : ", error);
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getFirstTestCode(tourId) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .get(`${apiHost}/firstTestCode/${tourId}`, {
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getTour(id) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .get(`${apiHost}/tour`, {
        params: {
          tourId: id,
        },
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        console.log("ApiTour getTour error ", error);
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  /**
   * Arborescence legere du parcours (parcours + zones + titres d'enigmes) en
   * un seul appel, pour le menu de navigation lateral.
   */
  static async getTourOutline(id) {
    return await apiClient
      .get(`${apiHost}/tourOutline`, {
        params: {
          tourId: id,
        },
      })
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getTourPublic(id) {
    return await apiClient
      .get(`${apiHost}/tourPublic`, {
        params: {
          tourId: id,
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  // Le classement public a besoin de savoir si le créateur du parcours y a
  // droit (question d'abonnement). Le back tranche et ne renvoie qu'un booléen :
  // le rôle du créateur n'a pas à sortir sur une page publique.
  static async getLeaderboardActivated(tourId) {
    return await apiClient
      .get(`${apiHost}/tourPublic/${tourId}/leaderboardActivated`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getTourCodes(tourId, searchTerm, page, pageSize) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .get(`${apiHost}/tourCodes`, {
        params: {
          tourId: tourId,
          page: page,
          pageSize: pageSize,
          searchTerm: searchTerm,
        },
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async duplicateTour(tourId) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(
        `${apiHost}/duplicateTour`,
        {
          tourId: tourId,
        },
        {
          // headers: { Authorization: authHeader },
        }
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async sendEmailNewCode(tourCodeId) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(
        `${apiHost}/sendEmailNewCode`,
        {
          tourCodeId: tourCodeId,
        },
        {
          // headers: { Authorization: authHeader },
        }
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async archiveTourCode(id) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(
        `${apiHost}/archiveTourCode`,
        {},
        {
          params: {
            tourCodeId: id,
          },
          // headers: { Authorization: authHeader },
        }
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }
  static async deleteTour(id) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .delete(`${apiHost}/tour`, {
        params: {
          tourId: id,
        },
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async updateTourMonetization(id, monetizationDatas) {
    return await apiClient
      .put(`${apiHost}/tour/updateTourMonetization/${id}`, {
        tourPrice: monetizationDatas.price,
        monetizationPaused: monetizationDatas.monetizationPaused,
        taxRateOptionId: monetizationDatas.taxRateOptionId,
        contactEmail: monetizationDatas.contactEmail,
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async uploadTourEmailIcon(id, file) {
    const dataForm = new FormData();
    dataForm.append("icon", file);

    return await apiClient
      .post(`${apiHost}/tour/uploadTourEmailIcon/${id}`, dataForm, {
        headers: { "content-type": "multipart/form-data" },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async deleteTourEmailIcon(id) {
    return await apiClient
      .delete(`${apiHost}/tour/tourEmailIcon/${id}`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  // Le back renvoie le HTML après nettoyage : la réponse fait autorité sur ce
  // qui a été réellement enregistré, il faut réinjecter sa valeur dans l'éditeur.
  static async updateBuyerEmailCustomText(id, buyerEmailCustomText) {
    return await apiClient
      .put(`${apiHost}/tour/updateBuyerEmailCustomText/${id}`, {
        buyerEmailCustomText: buyerEmailCustomText,
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  // Renvoie les options globales (OwnerUserId null) et les taux privés du
  // vendeur connecté, dans une seule liste.
  static async getTaxRateOptions() {
    return await apiClient
      .get(`${apiHost}/tour/taxRateOptions`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async createTaxRateOption(taxRateDatas) {
    return await apiClient
      .post(`${apiHost}/tour/taxRateOptions`, {
        country: taxRateDatas.country,
        percentage: taxRateDatas.percentage,
        displayName: taxRateDatas.displayName,
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getTemplateTours() {
    return await apiClient
      .get(`${apiHost}/templateTours`)
      .then((response) => ({
        status: response.status,
        data: response.data,
      }))
      .catch((error) => {
        if (error.response) {
          return { status: error.response.status, data: error.response.data };
        }
        return { status: 500, data: "Undefined error" };
      });
  }

  static async copyTemplateTour(tourId) {
    return await apiClient
      .post(`${apiHost}/copyTemplateTour`, { tourId })
      .then((response) => ({
        status: response.status,
        data: response.data,
      }))
      .catch((error) => {
        if (error.response) {
          return { status: error.response.status, data: error.response.data };
        }
        return { status: 500, data: "Undefined error" };
      });
  }

  static async requestTemplateTour(tourId) {
    return await apiClient
      .post(`${apiHost}/requestTemplateTour`, { tourId })
      .then((response) => ({
        status: response.status,
        data: response.data,
      }))
      .catch((error) => {
        if (error.response) {
          return { status: error.response.status, data: error.response.data };
        }
        return { status: 500, data: "Undefined error" };
      });
  }

  static async generateTourWithAI(
    prompt,
    aiTourIsQRCode,
    zonesNb,
    enigmasPerZone,
    generateImages
  ) {
    return await apiClient
      .post(`${apiHost}/generateTourWithAI`, {
        prompt,
        aiTourIsQRCode,
        zonesNb,
        enigmasPerZone,
        generateImages,
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };
        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }
        return errorLog;
      });
  }
}
